import { LOCALES } from '@/common/config'

export default {
  methods: {
    fetchLocale () {
      var locale = window.navigator.language.slice(0, 2).toLowerCase()
      var lsLocale = localStorage.getItem('locale')
      var url = new URL(document.location.href)
      var obj = {}

      for (var pair of url.searchParams.entries()) {
        obj[pair[0]] = pair[1].trim()
      }

      if (lsLocale && locale !== lsLocale) {
        locale = lsLocale
      }

      if (obj.locale && locale !== obj.locale) {
        locale = obj.locale
        localStorage.setItem('locale', obj.locale)
      }

      if (LOCALES.includes(locale)) {
        return locale
      }

      return 'en'
    }
  }
}
